import { render, staticRenderFns } from "./customerApplyList.vue?vue&type=template&id=19c4e2b4"
import script from "./customerApplyList.vue?vue&type=script&lang=js"
export * from "./customerApplyList.vue?vue&type=script&lang=js"
import style0 from "./customerApplyList.vue?vue&type=style&index=0&id=19c4e2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports